import { requestExpandedMode, context } from '@devvit/client';
import './challengeSplash.css';

const startButton = document.getElementById('start-button') as HTMLButtonElement;
const titleElement = document.getElementById('title') as HTMLHeadingElement;
const descriptionElement = document.getElementById('description') as HTMLParagraphElement;
const hostAvatarElement = document.getElementById('host-avatar') as HTMLImageElement;
const hostAvatarContainer = document.getElementById('host-avatar-container') as HTMLDivElement;
const hostLabelContainer = document.getElementById('host-label-container') as HTMLDivElement;
const hostAvatarLabel = document.getElementById('host-avatar-label') as HTMLSpanElement;

// Handle start button click - navigate to game entrypoint
startButton.addEventListener('click', async (e) => {
  console.log('Challenge: Start button clicked, requesting expanded mode...');
  try {
    await requestExpandedMode(e, 'game');
  } catch (error) {
    console.error('Failed to enter expanded mode:', error);
  }
});

// Display splashData directly from context (no API call needed!)
function displaySplashData() {
  const splashData = (context as any).postData;
  console.log('Challenge: splashData from context:', splashData);
  
  if (splashData) {
    const { hostUsername, hostLevel, isBotPost, hostAvatarUrl } = splashData;
    
    // Update title with host username
    titleElement.textContent = hostUsername?.toUpperCase() || 'CHALLENGER';
    
    // Update description with level info
    const botLabel = isBotPost ? ' (Bot)' : '';
    descriptionElement.textContent = `Level ${hostLevel}${botLabel} brawler is looking for a fight! Accept the challenge and battle for glory and rewards!`;
    
    // Display host avatar (use default if not available)
    hostAvatarElement.src = hostAvatarUrl || '/assets/Characters/default_snoovatar.png';
    hostAvatarLabel.textContent = `LVL ${hostLevel}`;
    hostAvatarContainer.style.display = 'block';
    hostLabelContainer.style.display = 'block';
  } else {
    // Fallback when no splashData
    titleElement.textContent = 'CHALLENGER';
    descriptionElement.textContent = 'A brawler is looking for a fight! Accept the challenge and battle for glory and rewards!';
    
    // Still show avatar container with default image
    hostAvatarElement.src = '/assets/Characters/default_snoovatar.png';
    hostAvatarLabel.textContent = 'HOST';
    hostAvatarContainer.style.display = 'block';
    hostLabelContainer.style.display = 'block';
  }
}

// Initialize the splash screen
function init() {
  console.log('Challenge splash initializing...');
  
  // Display splashData directly from context
  displaySplashData();
}

// Run initialization when DOM is ready
init();
